import { consolidateFrames } from '@utils/product';
import {
  shopifyAdminIdToGraphqlId,
  shopifyGraphqlIdToAdminId,
} from '@utils/shopifyIds';
import { useTranslation } from 'next-i18next';

import { FramePicker } from '../../../components/Containers/ReviewCheckoutDrawer/FramePicker';
import { useFlow } from '../../../providers';
import { usePreAuthDrawCtx } from '../../../providers/PreAuthDrawProvider';
import { usePurchase } from '../../../providers/PurchaseProvider';
import { CurrencyCode } from '../../../types/Locations';
import { DrawWithFrames } from '../types';

interface Props {
  drawWithFrames: DrawWithFrames;
  currencyCode?: CurrencyCode;
  frameByDefault?: boolean;
}

export const FrameStepDraw = ({
  currencyCode,
  drawWithFrames,
  frameByDefault,
}: Props) => {
  const { frames, product } = drawWithFrames;
  const { goToStep } = useFlow();
  const { customerSelectedFrame, setCustomerSelectedFrame } =
    usePreAuthDrawCtx();
  const purchasingController = usePurchase();
  const { t } = useTranslation(['product']);

  if (!frames) {
    return null;
  }

  const selectedFrameOnPage =
    shopifyGraphqlIdToAdminId(purchasingController.product?.shopifyId ?? '') ===
      drawWithFrames.product.shopifyId && purchasingController.frame
      ? purchasingController.frame
      : undefined;

  const shopifyId = shopifyAdminIdToGraphqlId(product.shopifyId);
  // unfortuantely we have to do this as this is the type FramePicker wants
  const consolidated = consolidateFrames({
    frameOptions: frames,
    selection: [
      {
        id: shopifyId,
        quantity: 1,
      },
    ],
    compositeImageProductShopifyId: shopifyId,
  });

  return (
    <FramePicker
      currencyCode={currencyCode}
      description={product.framingOffered}
      frameByDefault={frameByDefault}
      frameOptions={consolidated}
      frameSelected={
        customerSelectedFrame !== undefined
          ? customerSelectedFrame
          : selectedFrameOnPage || null
      }
      hideSubmitButton={false}
      hideTitle
      includeUnframed
      onGetInTouchClick={() => {
        window.open('/support/contact ', '_blank', 'noopener,noreferrer');
      }}
      onSubmit={(frame) => {
        setCustomerSelectedFrame(frame);
        goToStep('apply');
      }}
      productSubtotal={drawWithFrames.product.price}
      submitButtonLabel={t('drawers.review.framing.cta')}
    />
  );
};
